import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip, Grid, Typography } from '@mui/material';

import { Icon } from '@components/base';
import useLayoutEntityFilterContext from '@hooks/useLayoutEntityFilter';

type QuickAddTagFilterProps = {
  favoriteTags: string[];
};

const QuickAddTagFilter: FC<QuickAddTagFilterProps> = ({ favoriteTags }) => {
  const { t } = useTranslation();
  const { tagValues } = useLayoutEntityFilterContext();

  if (!tagValues) return null;

  const { setTags, tags } = tagValues;

  const onQuickAddTag = (tag: string) => setTags(tags.includes(tag) ? tags : [...tags, tag]);

  return favoriteTags.length > 0 ? (
    <Grid
      alignItems='center'
      container
      justifyContent='flex-end'
      maxWidth={1}
      ml='auto'
      size={{ xs: 12, sm: 'grow' }}
      spacing={1}
    >
      <Grid>
        <Typography variant='caption'>{t('tags.quickFilter')}:</Typography>
      </Grid>

      {favoriteTags.map(tag => (
        <Grid key={tag}>
          <Chip
            disabled={tags.includes(tag)}
            icon={<Icon name='tag' />}
            key={tag}
            label={tag}
            onClick={() => onQuickAddTag(tag)}
            size='small'
          />
        </Grid>
      ))}
    </Grid>
  ) : null;
};

export default QuickAddTagFilter;
